import React from 'react'
import { Box, Icon, Typography } from 'shared/ui'

export const AiAgentUserCell = () => (
  <Box display={'flex'} gap={'6px'}>
    <Icon icon={'stars'} color={'var(--purple-70)'} />
    <Typography ariaLabel={'agent'} variant={'body-md-regular'}>
      AI Agent
    </Typography>
  </Box>
)
